const NOTIFICATION = 'NOTIFICATION';
const ERROR = 'ERROR';
const CONFIRM = 'CONFIRM';
const DETAILS = 'DETAILS';
const FILTER = 'FILTER';

export const ModalTypes = { NOTIFICATION, ERROR, CONFIRM, DETAILS, FILTER };

class LkflModal {
  modalQueue = [];

  init(refModal) {
    this.refModal = refModal;
  }

  async show({ content }) {
    return await this.refModal.current.show({ content });
  }

  hide() {
    this?.refModal?.current && this.refModal.current.hide();
  }
}

export default new LkflModal();
